import { NgModule } from 'ng-metadata/core';
import {BrowserStorageManagerService} from './browserStorageManager.service';

@NgModule({
    declarations: [
        
    ],
    providers: [
        BrowserStorageManagerService
    ],
    imports:[

    ]
})
export class BrowserStorageManagerModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/browserStorageManager.module.ts